export default __webpack_public_path__ + "static/media/aboutIcon.ae3a914b.png";